import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    console.log("DeleteModal conectado")
  }

  open(event) {
    event.preventDefault()

    const url = event.currentTarget.dataset.deleteModalUrlValue

    const modalElement = document.getElementById("deleteModal")

    // salva a url no botão confirmar
    const confirmButton = modalElement.querySelector("[data-confirm]")
    confirmButton.dataset.url = url

    const modal = new bootstrap.Modal(modalElement)
    modal.show()
  }

  confirm(event) {
    event.preventDefault()

    const url = event.currentTarget.dataset.url
    if (!url) return

    const form = document.createElement("form")
    form.method = "POST"
    form.action = url

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = "delete"

    const csrfToken = document
      .querySelector("meta[name='csrf-token']")
      .getAttribute("content")

    const csrfInput = document.createElement("input")
    csrfInput.type = "hidden"
    csrfInput.name = "authenticity_token"
    csrfInput.value = csrfToken

    form.appendChild(methodInput)
    form.appendChild(csrfInput)

    document.body.appendChild(form)
    form.submit()
  }
}